// extracted by mini-css-extract-plugin
module.exports = {"tableTitle":"UserApplicationsPageView_tableTitle__guu5H"};